import { render, staticRenderFns } from "./MovementDetails.vue?vue&type=template&id=53ff04d3&scoped=true"
import script from "./MovementDetails.vue?vue&type=script&lang=js"
export * from "./MovementDetails.vue?vue&type=script&lang=js"
import style0 from "./MovementDetails.vue?vue&type=style&index=0&id=53ff04d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff04d3",
  null
  
)

export default component.exports